import { useEffect, useRef, useState } from 'react';
import { Actions as CoreActions, PageController } from '@sitecore-search/core';
import useBaseWidget from './useBaseWidget.js';
import useWidget from './useWidget.js';
const createProxy = (state, trackedProps) => {
    const result = {};
    // Loop on the property which are in the form state
    for (const propertyName in state) {
        if (propertyName !== 'request' && propertyName !== 'response') {
            Object.defineProperty(result, propertyName, {
                get: () => {
                    const key = propertyName;
                    // Keep in mind that the property is listened
                    trackedProps[key] = true;
                    // And returns the actual value
                    return state[key];
                },
            });
        }
    }
    return result;
};
const getTrackedState = (state, trackedProps) => {
    const result = Object.fromEntries(Object.entries(state).filter(([k]) => trackedProps[k]));
    if (Object.keys(result).length === 0) {
        return null;
    }
    return result;
};
const useWidgetState = () => {
    const control = useWidget();
    const { rfkId, instanceId } = useBaseWidget();
    const [state, updateState] = useState(control.state);
    const trackedProps = useRef({});
    useEffect(() => {
        const listener = {
            handleAction(action) {
                if (action.type === CoreActions.WIDGET_STATE_CHANGED) {
                    const { rfkId: id, instanceId: instance = null, state: newState } = action.payload;
                    if (id === rfkId && instanceId === instance) {
                        const trackedState = getTrackedState(newState, trackedProps.current);
                        if (trackedState) {
                            updateState((prevState) => ({ ...prevState, ...trackedState }));
                        }
                    }
                }
            },
        };
        PageController.register(listener);
        return () => PageController.unregister(listener);
    }, [rfkId, instanceId]);
    return createProxy(state, trackedProps.current);
};
export default useWidgetState;
